
import React from 'react';
import { TabPanel } from 'devextreme-react';
import { Item } from 'devextreme-react/tab-panel';
import Get_Courses_User from '../../components/Courses/DataCourses_User'
import '../Cuorses/CoursePg.module.scss'

export default function CoursePg() {
    return (
        <React.Fragment>
            <div className={'content-course dx-card responsive-paddings ContenedorCourses'} style={{ margin: "30px auto 30px auto", width: "95%" }}>
                <TabPanel
                    className="dx-theme-background-color TabPanelCursos"
                    showNavButtons={true}
                    animationEnabled={true}
                    swipeEnabled={true}
                    tabsPosition='top'
                    stylingMode='primary'
                    iconPosition='top'
                    width={"100%"}
                >
                    <Item title='Pendientes' icon='description'>
                        <Get_Courses_User status={["Pending"]}></Get_Courses_User>
                    </Item>
                    <Item title='Contestados' icon='taskcomplete'>
                        <Get_Courses_User status={["Completed"]}></Get_Courses_User>
                    </Item>
                </TabPanel>
            </div>
        </React.Fragment>
    )
}